import filesApi from '.'
import { getAuthHeaders } from 'utils/requests'

// Upload de arquivo do cliente (S3)
// payload: FormData com field 'file' + (clientId/processoId/despesaId no body ou query)
const uploadFile = async (formData, params = {}) => {
  const headers = { headers: getAuthHeaders() }

  // Envia via query pra não depender do backend interpretar multipart fields (mais simples)
  const query = new URLSearchParams()
  if (params.clientId) query.set('clientId', params.clientId)
  if (params.processoId) query.set('processoId', params.processoId)
  if (params.despesaId) query.set('despesaId', params.despesaId)
  if (params.folderId) query.set('folderId', params.folderId)

  const qs = query.toString()
  const url = qs ? `/upload?${qs}` : '/upload'

  return await filesApi.post(url, formData, headers)
}

export default uploadFile
